
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-text-field
              label="Nome"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="CPF"
              v-model="form.filters.cpf"
              v-mask="'###.###.###-##'"
              maxlength="14"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Situação"
              v-model="form.filters.situacao"
              outlined
              dense
              :items="form.lists.listSituacoes"
              item-text="descricao"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              label="Lotação"
              v-model="form.filters.lotacao"
              outlined
              dense
              :items="form.lists.listLotacoes"
              item-text="nome"
              return-object
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-select
              label="Função"
              v-model="form.filters.funcao"
              outlined
              dense
              :items="form.lists.listFuncoes"
              item-text="nome"
              item-value="id"
            ></v-select>
          </v-col>
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicial"
            removeIcon
            outlined
            dense
            ></sca-date-picker>
          <sca-date-picker
            :cols="2"
            label="Data Final"
            v-model="form.filters.dataFinal"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios()"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headers"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        :sort-desc="true"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.cpf`]="{ item }">
          {{ $formatCpf(item.cpf) }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorio('PDF')"
        @cancel="baixarRelatorio('CSV')"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
import RelatorioLogSolicitacoesAcessoService from "~/services/relatorios-log/manter-solicitacoes-acesso-log.service";
import SolicitacoesDeAcessoService from '~/services/solicitacoes-acesso.service';
import PreLoginService from "~/services/pre-login.service";
import DataTableMixin from "~/mixins/datatables.mixin";
import FormatoArquivoEnum from "~/commons/enums/formato-arquivo.enum";

export default {
  name: "RelatorioLogSolicitacoesAcesso",
  mixins: [
    RelatorioLogSolicitacoesAcessoService,
    SolicitacoesDeAcessoService,
    PreLoginService,
    DataTableMixin
  ],
  data: () => ({
    form: {
      filters: {
        nome: null,
        cpf: null,
        lotacao: null,
        funcao: null,
        situacao: null,
        dataInicial: null,
        dataFinal: null,
      },
      lists: {
        listRelatorios: [],
        listLotacoes: [],
        listFuncoes: [],
        listSituacoes: [],
      }
    },
    headers: [
      { text: "Nome", align: "center", value: "nome" },
      { text: "CPF", align: "center", value: "cpf" },
      { text: "Lotação", align: "center", value: "lotacao.nome" },
      { text: "Função", align: "center", value: "funcao.nome" },
      { text: "Situação", align: "center", value: "situacao.nome" },
      { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
      { text: "Ação", align: "center", value: "acao" },
    ]
  }),
  methods: {
    async buscarRelatorios() {
      if (this.validarDatas() && this.verificarFiltrosPreenchidos()) {
        const { data } = await this.$obterRelatorioLogSolicitacoesAcesso({ params: this.payload });
        this.form.lists.listRelatorios = data.lista;
      }
    },
    validarDatas() {
      const { dataInicial, dataFinal } = this.form.filters;
      if (dataInicial && dataFinal) {
        if (new Date(dataFinal) < new Date(dataInicial)) {
          return this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
        }
      }
      return true;
    },
    verificarFiltrosPreenchidos() {
      const { dataInicial, dataFinal, situacao, nome, cpf, lotacao, funcao } = this.form.filters;
      if (situacao == null && !dataInicial && !dataFinal && !nome && !cpf && !lotacao && !funcao) {
        return this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
      }
      return true;
    },
    async baixarRelatorio(formato) {
      switch (formato) {
        case FormatoArquivoEnum.CSV:
          return this.baixarRelatorioCSV();
        case FormatoArquivoEnum.PDF:
          return this.baixarRelatorioPDF();
        default:
          return this.$notifyWarning("Formato de relatório inválido.");
      }
    },
    async baixarRelatorioCSV() {
      const { data } = await this.$obterRelatorioLogCSVSolicitacoesAcesso({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.${this.$options.name}${FormatoArquivoEnum.CSV}`, "Operação realizada com sucesso.");
    },
    async baixarRelatorioPDF() {
      const { data } = await this.$obterRelatorioLogPDFSolicitacoesAcesso({ params: this.form.filters });
      this.$baixarRelatorioPDF(data, `SCA.${this.$options.name}${FormatoArquivoEnum.PDF}`, "Operação realizada com sucesso.");
    },
    buscarLotacoes() {
      this.$obterLotacoes().then(({ data }) => this.form.lists.listLotacoes = data.lista);
    },
    buscarFuncoes() {
      this.$obterFuncoes({ params: { listarInativos: true } }).then(({ data }) => this.form.lists.listFuncoes = data.lista);
    },
    buscarSituacoes() {
      this.$buscarSituacoesSolicitacoesDeAcesso().then(({ data }) => this.form.lists.listSituacoes = data.itens);
    },
    resetForm() {
      this.form.filters.lotacao = null;
      this.$clearFilters(this.form.filters);
      this.$clearFilters(this.form.lists.listRelatorios);
    },
  },
  computed: {
    payload() {
      const payload = { ...this.form.filters };
      payload.cpf = this.$unMask(this.form.filters.cpf);
      payload.lotacao = this.form.filters.lotacao?.id || null;
      return payload;
    }
  },
  mounted() {
    this.buscarSituacoes();
    this.buscarLotacoes();
    this.buscarFuncoes();
  }
};
</script>
